import  theme_config  from "../../config";

export const loadThemeColors = async () => {
    try {
        const colorData = await import(`../assets/colorThemes/${theme_config.theme}`);

        const root = document.documentElement;

        Object.keys(colorData.MAIN_THEME_COLORS).forEach((key) => {
            root.style.setProperty(`--${key.toLowerCase()}`, colorData.MAIN_THEME_COLORS[key]);
        });

        return colorData;
    } catch (error) {
        console.error("Error loading theme colors:", error);
        return null;
    }
};

export const getAppLogo = async (currentTheme) => {
    const { IMAGES } = await import("../assets");

   
    if (currentTheme == 'light') {
        return IMAGES.client_logo_light;
    }
    else if (currentTheme == 'dark') {
        return IMAGES.client_logo_dark;
    }
    else {
        return IMAGES.client_logo_light;
    }
};
